<template>
  <el-dialog :visible="dialogVisible" width="260px" :modal-append-to-body="false" @close="close">
    <div class="md__sign_officewebsite_phonecallconsult_content">
      <a :href="`tel:${info.tel}`" @click="handlePhoneClick()" class="mb_mask_o_phone_number_box first">
        <p class="mb_mask_o_discription">销售热线：</p>
        <p class="mb_mask_o_phone_number">{{ info.tel }}</p>
      </a>
      <a v-if="!isGuangshou" href="tel:4000878198" @click="handlePhoneClick()" class="mb_mask_o_phone_number_box second">
        <p class="mb_mask_o_discription">售后服务：</p>
        <p class="mb_mask_o_phone_number">400-0878-198</p>
      </a>
    </div>
  </el-dialog>
</template>

<script>
import { hostToBusinessInfo } from '@/utils'
export default {
  name: 'PhoneDialog',
  props: {
    dialogVisible: { type: Boolean, default: false },
  },
  computed: {
    // 广州代理商落地页域名
    isGuangshou() {
      return window.location.hostname === 'guangzhou.esign.cn'
    },
    info() {
      return hostToBusinessInfo()
    },
  },
  methods: {
    handlePhoneClick() {
      // TODO:
      if (this.landingPageName === 'esignPropagate') {
        window.meteor && window.meteor.track && window.meteor.track('phone', { convert_id: '1655142884209676' })
      }
      this.$tsignData.track('sign_olandingpage_phonecallconsult')
      this.$tsignData.track('click_phone_call')
    },
    close() {
      this.$emit('update:dialogVisible', false)
    },
  },
}
</script>

<style scoped lang="less">
/deep/ .el-dialog {
  padding: 0 !important;
  margin: 0 !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.el-dialog__body {
  padding: 0;
}
.md__sign_officewebsite_phonecallconsult_content {
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 260px;
  background: #ffffff;
  border-radius: 4px;
  padding: 0 14px;
}
.mb_mask_o_phone_number_box {
  height: 60px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0px solid #f2f2f2;
  border-bottom-width: 1px;
  &:last-child {
    border-bottom-width: 0;
  }
}
.mb_mask_o_phone_number_box .mb_mask_o_discription {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
}
.mb_mask_o_phone_number_box .mb_mask_o_phone_number {
  font-size: 16px;
  font-weight: 400;
  color: #e61717;
}
</style>
